<template>
  <v-card tile outlined flat>
    <v-toolbar flat height="auto" class="py-3">
      <v-row>
        <v-col cols="auto" align-self="center" justify-self="center">
          <v-toolbar-title class="title font-weight-bold" v-if="title">{{ title }}</v-toolbar-title>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" align-self="center" justify-self="center" class="flex-grow-1">
          <v-text-field
            v-if="searchable"
            rounded
            :value="search"
            @input="searchResults"
            outlined
            solo
            single-line
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search"
            :height="10"
            clearable
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <!-- download csv btn -->
        <v-col v-if="csv" cols="auto" align-self="center" justify-self="end">
          <!-- <v-btn
            color="primary"
            fab
            small
            :loading="loadingCsv"
            :disabled="loadingCsv"
            @click="downloadCsv"
            title="Download CSV of Data"
          > -->
          <v-btn
            v-if="!hideDownloadTranfer"
            color="primary"
            :loading="loadingCsv"
            :disabled="loadingCsv"
            @click="downloadCsv"
            title="Download CSV of Data"
          >
            <v-icon>mdi-cloud-download</v-icon>
            {{ "Download " + title }}
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" align-self="center" justify-self="center">
          <slot name="action.icons"></slot>
        </v-col>
      </v-row>
    </v-toolbar>
    <v-data-table
      :headers="preparedHeaders"
      :items="items"
      :search="search"
      disable-sort
      :options.sync="options"
      :loading="loading"
      @click:row="$emit('click:row', $event)"
      :server-items-length="totalItemsCount"
      fixed-header
      v-bind="$attrs"
      :items-per-page="25"
      :footer-props="footerProps"
    >
      <v-progress-linear slot="progress" active indeterminate stripped :height="6" />
      <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
      <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData">
        <slot :name="name" v-bind="slotData" />
      </template>

      <template v-slot:top>
        <!-- <v-row class="pl-4 align-baseline" justify="end"> -->
        <v-row class="pl-4 align-baseline">
          <v-col v-if="dateSort" cols="12" sm="6" md="2">
            <v-menu
              v-model="fromMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFrom"
                  label="From:"
                  append-icon="mdi-calendar"
                  readonly
                  @click:clear="resetFromDate()"
                  clearable
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dateFrom" @input="fromMenu = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col v-if="dateSort" cols="12" sm="6" md="2">
            <v-menu
              v-model="toMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateTo"
                  label="To:"
                  append-icon="mdi-calendar"
                  readonly
                  @click:clear="resetToDate()"
                  clearable
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dateTo" @input="toMenu = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col v-if="dateSort" class="my-2 d-flex justify-center" cols="12" sm="6" md="5">
            <v-btn @click="getDateRange" class="ma-2" color="primary">Get Date Range</v-btn>
            <v-btn v-if="dateSort" @click="resetDateRange" class="ma-2" color="primary"
              >Reset Date Range</v-btn
            >
          </v-col>

          <!-- filter section -->
          <!-- <v-row v-if="userFilter" class="pl-4 ml-1 flex flex-col align-center flex-wrap"> -->
          <v-col v-if="userFilter" xl="2" lg="2" sm="3" md="2">
            <v-text-field
              class="mr-2"
              :value="userFilterParams.email"
              variant="solo-inverted"
              @input="(event) => handleUserFilter(event, 'email')"
              label="Email"
            ></v-text-field>
          </v-col>
          <v-col v-if="userFilter" xl="2" lg="2" sm="3" md="2">
            <v-text-field
              class="mr-2"
              :value="userFilterParams.country"
              variant="solo-inverted"
              @input="(event) => handleUserFilter(event, 'country')"
              label="Country"
            ></v-text-field>
          </v-col>
          <v-col v-if="userFilter" xl="2" lg="2" sm="3" md="2">
            <v-select
              v-model="userTypeFilterSelected"
              :items="userTypeFilterOptions"
              item-title="heading"
              item-text="heading"
              item-value="filterValue"
              label="Type"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-col>
          <!-- new line -->
          <!-- <v-text-field
              class="mr-2"
              :value="userFilterParams.type"
              variant="solo-inverted"
              @input="(event) => handleUserFilter(event, 'type')"
              label="Type"
            ></v-text-field> -->
          <!-- <v-btn @click="activateExtraFilter" class="mr-2" color="primary">
              Filter
            </v-btn> -->
          <v-btn v-if="userFilter" @click="resetUserFilter" class="mr-2" color="primary">
            Reset Filter
          </v-btn>
          <!-- </v-row> -->

          <!-- comapany filter -->
          <v-row v-if="companyFilter" class="pl-4 ml-1 flex flex-col align-center flex-wrap">
            <v-col xl="2" lg="2" sm="3" md="2">
              <v-text-field
                class="mr-2"
                :value="companyFilterParams.location"
                variant="solo-inverted"
                @input="(event) => handleCompanyFilter(event, 'location')"
                label="Location"
              ></v-text-field>
            </v-col>
            <v-col xl="2" lg="2" sm="3" md="2">
              <v-text-field
                class="mr-2"
                :value="companyFilterParams.country"
                variant="solo-inverted"
                @input="(event) => handleCompanyFilter(event, 'country')"
                label="Country"
              ></v-text-field>
            </v-col>
            <v-col xl="2" lg="2" sm="3" md="2">
              <v-text-field
                class="mr-2"
                :value="companyFilterParams.owner"
                variant="solo-inverted"
                @input="(event) => handleCompanyFilter(event, 'owner')"
                label="Owner"
              ></v-text-field>
            </v-col>
            <!-- <v-btn @click="activateExtraFilter" class="mr-2" color="primary">
              Filter
            </v-btn> -->
            <v-col sm="2" md="2" lg="2" xs="2">
              <v-btn @click="resetExtraFilter" class="mr-2" color="primary">
                Reset Filter
              </v-btn>
            </v-col>
          </v-row>

          <v-col v-if="archive" class="ms-auto" cols="12" sm="6" md="3">
            <v-switch
              class="d-flex justify-end pr-6"
              v-model="withArchived"
              label="Show archived"
            ></v-switch>
          </v-col>
        </v-row>

        <!-- transfer filter -->
        <v-row v-if="transferFilter" class="ml-1 flex flex-col align-center flex-wrap">
          <v-col xl="2" lg="2" sm="3" md="2">
            <v-text-field
              class="mr-2"
              :value="transferFilterParams.senderName"
              variant="solo-inverted"
              @input="(event) => handleTransferFilter(event, 'senderName')"
              label="Sender name"
            ></v-text-field>
          </v-col>
          <v-col xl="2" lg="2" sm="3" md="2">
            <v-text-field
              class="mr-2"
              :value="transferFilterParams.receipentName"
              variant="solo-inverted"
              @input="(event) => handleTransferFilter(event, 'receipentName')"
              label="Receiver name"
            ></v-text-field>
          </v-col>
          <v-col xl="2" lg="2" sm="3" md="2">
            <v-select
              v-model="transferStatusSelected"
              :items="transferStatusOptions"
              item-title="heading"
              item-text="heading"
              item-value="filterValue"
              label="transfer status"
              persistent-hint
              return-object
            ></v-select>
            <!-- <v-text-field
              class="mr-2"
              :value="transferFilterParams.transfer_status"
              variant="solo-inverted"
              @input="(event) => handleTransferFilter(event, 'transfer_status')"
              label="Transfer status"
            ></v-text-field> -->
          </v-col>
          <v-col xl="2" lg="2" sm="3" md="2">
            <v-select
              v-model="paymentStatusSelected"
              :items="paymentStatusOptions"
              item-title="heading"
              item-text="heading"
              item-value="filterValue"
              label="payment status"
              persistent-hint
              return-object
            ></v-select>
            <!-- <v-text-field
              class="mr-2"
              :value="transferFilterParams.payment_status"
              variant="solo-inverted"
              @input="(event) => handleTransferFilter(event, 'payment_status')"
              label="Payment status"
            ></v-text-field> -->
          </v-col>
          <!-- <v-btn @click="activateExtraFilter" class="mr-2" color="primary">
            Filter
          </v-btn> -->
          <v-col sm="2" md="2" lg="2" xs="2">
            <v-btn @click="resetTransferFilter" class="mr-2" color="primary">
              Reset Filter
            </v-btn>
          </v-col>
        </v-row>

        <slot name="action.top"></slot>
      </template>

      <template slot-scope="{ item }" v-for="(field, i) in progressFields" :slot="'item.' + field">
        <v-icon color="success" v-if="item[field]" :key="i">mdi-shield-check</v-icon>
        <v-icon color="warning" v-else :key="i">mdi-information-outline</v-icon>
      </template>
      <template
        slot-scope="{ item }"
        v-for="(field, ind) in progressFields"
        :slot="'item.' + field"
      >
        <v-icon color="success" v-if="item[field]" :key="ind">mdi-shield-check</v-icon>
        <v-icon color="warning" v-else :key="ind">mdi-information-outline</v-icon>
      </template>

      <!--       item field slots -->
      <template slot-scope="{ item }" v-for="(_, name) in fields" :slot="'item.' + name">
        <keep-alive :key="name">
          <formated-row :name="name" :item="item" />
        </keep-alive>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import get from "lodash/get";
import debounce from "lodash/debounce";
import qs from "qs";
import { AsyncParser } from "json2csv";

import prepareItem from "./prepareItem";
import FormatedRow from "./formatedRow";
import { downloadFile } from "./utils";

export default {
  components: { FormatedRow },
  props: {
    headers: { required: true, type: [Array, Object] },
    paginated: { default: true },
    archive: { default: false },
    dateSort: { default: false },
    userFilter: { default: false },
    transferFilter: { default: false },
    csv: { default: false },
    hideDownloadTranfer: { default: false },
    companyFilter: { default: false },
    csvFileName: { default: "data.csv", type: String },
    csvFields: { default: () => [], type: Array },
    searchable: { default: false, type: Boolean },
    sortBy: { default: () => [], type: [Array, String] },
    url: { required: true },
    title: { type: String },
    csvParams: { type: Object, default: () => {} },
    fields: { type: Object, default: () => ({}) },
    progressFields: { type: Array, default: () => [] },
    footerProps: {
      default() {
        return { itemsPerPageOptions: [10, 15, 25] };
      },
    },
  },

  data() {
    return {
      abortController: null,
      dateFrom: null,
      dateTo: null,
      fromMenu: false,
      toMenu: false,
      menu2: false,
      withArchived: false,
      loading: true,
      loadingCsv: false,
      items: [],
      allItems: [],
      userFilterParams: { email: "", country: "", type: "" },
      isUserFilterOn: false,
      userTypeFilterSelected: undefined,
      userTypeFilterOptions: ["Customer", "Temporary-customer"],

      companyFilterParams: { location: "", country: "", owner: "" },
      isCompantFilterOn: false,

      transferFilterParams: {
        senderName: "",
        receipentName: "",
        transfer_status: "",
        payment_status: "",
      },
      transferStatusSelected: undefined,
      paymentStatusSelected: undefined,
      transferStatusOptions: [
        "started",
        "completed",
        "error",
        "failed",
        "pending",
        "verified",
        "initiated",
        "suspicious",
        "validated",
      ],
      paymentStatusOptions: [
        "started",
        "completed",
        "error",
        "failed",
        "pending",
        "verified",
        "initiated",
        "suspicious",
        "validated",
      ],
      // in the beforeDestroy method this will have changed so we persist it
      routeName: this.$route.name,
      totalItemsCount: 0,
      search: "",
      options: {
        sortBy: this.sortBy,
      },
    };
  },
  created() {
    // look for the date params and fill them
    const storageKey = `URL_PARAM_DATA:${this.$route.name}`;
    const paramData = localStorage.getItem(storageKey);
    if (paramData) {
      const values = qs.parse(paramData, { delimiter: /[&]/ });
      this.dateTo = values.dateTo;
      this.dateFrom = values.dateFrom;
      this.withArchived = values.withArchived === "true" ? true : false;
      if (!!this.dateFrom && !!this.dateTo) {
        this.getDateRange();
      }
      // delete them after filling them to avoid re-assignment
      localStorage.removeItem(storageKey);
    }

    this.emitFilterChange = debounce((params) => {
      this.$emit("filter-changed", params);
    }, 300);

  },

  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
    
    if (this.emitFilterChange && typeof this.emitFilterChange.cancel === 'function') {
      this.emitFilterChange.cancel();
    }


    // persist the date params
    const dates = { dateFrom: this.dateFrom, dateTo: this.dateTo, withArchived: this.withArchived };
    localStorage.setItem(`URL_PARAM_DATA:${this.routeName}`, qs.stringify(dates));
  },
  methods: {
    // store values of extra filters
    handleUserFilter(value, label) {
      // set filter data in state
      this.userFilterParams = { ...this.userFilterParams, [label]: value };

      // filtered array
      const filterFields = Object.keys(this.userFilterParams).filter(
        (extraField) => this.userFilterParams[extraField] !== "",
      );
      if (filterFields.length > 0) {
        const filteredArr = this.prepareItems(this.allItems).data.filter((item) => {
          return filterFields.every((filterItm) => {
            if (item[filterItm] == null && filterItm !== "type") {
              return false;
            } else if (filterItm !== "type") {
              return item[filterItm]
                .toString()
                .toLowerCase()
                .includes(this.userFilterParams[filterItm].toString().toLowerCase());
            } else {
              return (
                item["client"][filterItm].toString().toLowerCase() ==
                this.userFilterParams[filterItm].toString().toLowerCase()
              );
            }
          });
        });
        this.items = filteredArr;
      }
    },

    handleCompanyFilter(value, label) {
     this.companyFilterParams = { ...this.companyFilterParams, [label]: value };
     this.emitFilterChange({ ...this.companyFilterParams });
    },

    // handle transfer filtering
    handleTransferFilter(value, label) {
      // set filter data in state
      this.transferFilterParams = { ...this.transferFilterParams, [label]: value };
      this.debounedSearch(this, "");
    },

    // reset extra filters
    resetUserFilter() {
      this.userFilterParams = { email: "", country: "", type: "" };
      this.fetchData();
      this.userTypeFilterSelected = undefined;
    },

    // reset transfer filters
    resetTransferFilter() {
      (this.transferFilterParams = {
        senderName: "",
        receipentName: "",
        transfer_status: "",
        payment_status: "",
      }),
        (this.transferStatusSelected = undefined);
      this.paymentStatusSelected = undefined;
      this.fetchData();
    },

    // activate extra filter
    activateExtraFilter() {
      this.isUserFilterOn = true;
      this.isCompanyFilterOn = true;
    },

    // reset extra filters
    resetExtraFilter() {
      this.companyFilterParams = { location: "", country: "", owner: "" };
      this.emitFilterChange({ ...this.companyFilterParams })
    },

    downloadCsv() {
      this.loadingCsv = true;
      let csv = "";
      const fields = this.csvFields;

      this.$emit("loadingTransfer", true);

      const asyncParser = new AsyncParser({ fields }, { objectMode: true });
      asyncParser.processor
        .on("data", (chunk) => (csv += chunk.toString()))
        .on("end", () => downloadFile(csv, this.csvFileName))
        // eslint-disable-next-line no-unused-vars
        .on("error", (err) => {
          // console.error(err)
          csv = "";
        });

      this.fetchCsvData(this.url, asyncParser)
        .then(() => {
          Notify.success("Data has been successfully downloaded");
        })
        .catch(() => {
          // if there is an error, we clear the csv data
          csv = "";
        })
        .finally(() => {
          this.loadingCsv = false;
          this.$emit("loadingTransfer", false);
        });
    },

    fetchCsvData(url, asyncParser) {
      // all the data
      return this.$http
        .get(url, { params: this.csvParams })
        .then((response) => {
          response.data.forEach((item) => {
            asyncParser.input.push(item);
          });
          if (response.next_page_url) {
            return this.fetchCsvData(response.next_page_url, asyncParser);
          } else {
            asyncParser.input.push(null);
            return Promise.resolve(response);
          }
        })
        .catch((error) => {
          const message = get(
            error,
            " response.data.message",
            "Something went wrong while fetching csv data",
          );
          Notify.warning(message);
        });
    },
    resetDate() {
      this.dateFrom = null;
      this.dateTo = null;
    },
    getDateRange() {
      // ensure that a date has been selected
      if (this.dateFrom === null && this.dateTo === null) {
        Notify.error("Please select a date");
        return;
      }
      // ensure that the date to is not less that the date from
      else if (Date.parse(this.dateTo) < Date.parse(this.dateFrom)) {
        Notify.error("'Date To:' should be greater than 'Date From:'");
        return;
      }
      const data = [
        { name: "from", value: this.dateFrom },
        { name: "to", value: this.dateTo },
      ];
      const params = this.addParams(this.$parent.url, data);
      const url_section = this.$parent.url.split("?")[0];
      // emit the new url in an event
      this.$emit("date-range-updated", `${url_section}?${params}`);
    },

    // clearing date functions
    resetFromDate() {
      // this.resetDate();
      const data = [
        { name: "from", value: "" },
        { name: "to", value: this.dateTo },
      ];
      const params = this.addParams(this.$parent.url, data);
      const url_section = this.$parent.url.split("?")[0];
      // emit the new url in an event
      this.$emit("date-range-updated", `${url_section}?${params}`);
    },
    resetToDate() {
      // this.resetDate();
      const data = [
        { name: "from", value: this.dateFrom },
        { name: "to", value: "" },
      ];
      const params = this.addParams(this.$parent.url, data);
      const url_section = this.$parent.url.split("?")[0];
      // emit the new url in an event
      this.$emit("date-range-updated", `${url_section}?${params}`);
    },

    resetDateRange() {
      this.resetDate();
      const data = [
        { name: "from", value: "" },
        { name: "to", value: "" },
      ];
      const params = this.addParams(this.$parent.url, data);
      const url_section = this.$parent.url.split("?")[0];
      // emit the new url in an event
      this.$emit("date-range-updated", `${url_section}?${params}`);
    },
    // updates the parameters on the url ensuring that the existing ones are kept
    addParams(url, newParams) {
      const paramString = url.split("?")[1];
      let params = qs.parse(paramString, { delimiter: /[&]/ });
      newParams.forEach((param) => {
        // if no value was submitted, we remove that parameter
        if (!param.value) {
          delete params[`${param.name}`];
        } else {
          params[`${param.name}`] = param.value;
        }
      });
      return qs.stringify(params);
    },

    // api call for data
    fetchData(currentPage = 1) {
      this.loading = true;
      // Cancel previous request if it's still running
      if (this.abortController) {
        this.abortController.abort();
      }

      // Create new AbortController for this request
      this.abortController = new AbortController();

      const params = {
        page: currentPage || this.options.page,
        // page: this.options.page,
        per_page: this.options.itemsPerPage,
        sender:
          this.transferFilterParams.senderName !== "" ? this.transferFilterParams.senderName : null,
        receiver:
          this.transferFilterParams.receipentName !== ""
            ? this.transferFilterParams.receipentName
            : null,
        status:
          this.transferFilterParams.transfer_status !== ""
            ? this.transferFilterParams.transfer_status
            : null,
        payment_status:
          this.transferFilterParams.payment_status !== ""
            ? this.transferFilterParams.payment_status
            : null,
      };

      if (this.search) {
        params.search = this.search;
      }

      return this.$http
        .get(this.url, { 
          params,
          signal: this.abortController.signal,
        })
        .then((response) => {
          if (this.paginated) {
            this.setPaginationResults(response);
          } else {
            this.items = this.prepareItems(response);
          }
          this.allItems = response;
          return Promise.resolve(response);
        })
        .catch((error) => {
          if (error.name === 'CanceledError' || error.name === 'AbortError') {
            console.log('Previous request was aborted.');
            return;
          }
          
          const message = get(
            error,
            " response.data.message",
            "Something went wrong while fetching table data",
          );
          Notify.warning(message);
        })
        .finally(() => (this.loading = false));
    },
    setPaginationResults(results) {
      const { data, total } = results;
      this.items = this.prepareItems(data);
      this.totalItemsCount = total;
    },
    prepareItems(items) {
      if (Array.isArray(items)) {
        return items.map((item) => prepareItem(item, this.fields));
      }
      return items;
    },
    debounedSearch: debounce(function (vm, search) {
      vm.fetchData(1, { search });
    }, 500),
    searchResults(value) {
      this.search = value;
      this.debounedSearch(this, value);

      // set page number to 1
      this.options.page = 1;
    },
    replaceItem(replacement, keyName = "id", keyValue = null) {
      const value = keyValue === null ? get(replacement, keyName) : keyValue;

      if (value === null || value === undefined) {
        return;
      }
      const index = this.items.findIndex((item) => get(item, keyName) === value);

      if (index > -1) {
        this.$set(this.items, index, replacement);
      }
    },
  },
  watch: {
    options(options) {
      this.fetchData(options.page);
    },
    withArchived: function (val) {
      this.$emit("update-archived", val);
    },
    userTypeFilterSelected(val) {
      this.handleUserFilter(val, "type");
    },
    paymentStatusSelected(val) {
      if (val !== undefined) {
        this.handleTransferFilter(val, "payment_status");
      }
    },
    transferStatusSelected(val) {
      if (val !== undefined) {
        this.handleTransferFilter(val, "transfer_status");
      }
    },
  },
  computed: {
    preparedHeaders() {
      if (Array.isArray(this.headers)) {
        return this.headers;
      }
      return Object.keys(this.headers).map((value) => ({
        value,
        text: this.headers[value],
      }));
    },
  },
};
</script>
<style lang="scss">
.v-data-table__wrapper {
  td {
    cursor: pointer;
  }
}
</style>
